import { createAction } from '@reduxjs/toolkit';

import { type IGetLicensesParams } from '../services/licensesApiService';

export const getLicenses = createAction<IGetLicensesParams>('getLicenses');
export const getNewLicenses = createAction<IGetLicensesParams>('getNewLicenses');
